new Swiper('.custom-collection-main-box', {
     pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
     breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
         580: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
     },
});
